import React, { useState } from 'react';
import Info from '~components/Form/components/Info';
import { InfoForm } from '~misc/icons';

const Tooltip = () => {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <div className="relative flex items-center space-x-2">
      <div
        className="relative"
        onClick={() => setShowTooltip(!showTooltip)}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
      >
        <InfoForm />

        {showTooltip && (
         <div className="absolute left-full top-1/2 -translate-y-1/2 ml-2 p-2 w-auto whitespace-nowrap bg-[#034EA2] text-white text-sm rounded shadow-lg z-10">
            Produtos que estão habilitados para compra neste cliente
          </div>
        )}
      </div>
    </div>
  );
};

export default Tooltip;
